import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29dc0c7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "browser-type-list" }
const _hoisted_2 = { class: "browserType-cascader" }
const _hoisted_3 = { class: "browserType-search" }

import { BrowserGetters, BrowserMutations, BrowserActions } from '@/store/modules/browser';
import { BrowserAPI } from '@/api/browser';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ref, computed, onMounted, watchEffect } from "vue";
import { Search, CloseBold } from "@element-plus/icons-vue";
import { ElMessage } from 'element-plus'


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "BrowserTypeList",
});



export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const cascaderRef = ref()
const route = useRoute();
const store = useStore();
const selected = ref([] as string[]);
const searchFilter = ref<boolean>(false)
const searchType = ref<boolean>(true)
const searchInput = ref<string>("");
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);

const typeList = computed(() => {
    return store.getters[`browser/${BrowserGetters.getTypeList}`]
});

const isTypesLoading = computed(() => {
    return store.getters[`browser/${BrowserGetters.getTypesLoading}`]
});

const browserTaskIdList = computed(() => {
    return store.getters[`browser/${BrowserGetters.getTaskIdList}`]
});
const selectedTaskId = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSelectedTaskId}`]
});

const selectedBrowserType = computed(() => {
    return store.getters[`browser/${BrowserGetters.getSelectType}`]
});

const isSearching = computed(() => {
    return store.getters[`browser/${BrowserGetters.getIsSearching}`]
});
const handleChangeSearchInputFilter = () => {
    store.commit(`browser/${BrowserMutations.setSearchFilter}`, searchFilter.value)
}
const handleChangeSearchType = () => {
    store.commit(`browser/${BrowserMutations.setSearchType}`, searchType.value)
}
const asyncGetPaginationByBrowserType = async (projId: string, uid: string, taskId: string, pageSize: number, pageNum: number) => {
    await store.dispatch(`browser/${BrowserActions.asyncGetBrowserDetailsByPage}`, { projId, uid, ...selectedBrowserType.value, taskId, pageSize, pageNum })
}

const handleChange = (selected: string[]) => {
    searchInput.value = ""
    if (selected !== null) {
        store.commit(`browser/${BrowserMutations.setIsSearching}`, false)
        store.commit(`browser/${BrowserMutations.setSelectedType}`, { ...selectedBrowserType.value, browserType: selected[0], browserUser: selected[1], infoType: selected[2] });
        asyncGetPaginationByBrowserType(projectId.value, targetId.value, selectedTaskId.value, 10, 1)
    }
}
const asyncGetTypeList = async (projId: string, uid: string, taskId: string) => {
    await store.dispatch(`browser/${BrowserActions.asyncGetTypeList}`, { projId, uid, taskId });
};

const asyncGetTarget = async () => {
    const projId = projectId.value;
    let uid = targetId.value
    let target = searchInput.value
    let taskId = searchFilter.value === false ? "" : selectedTaskId.value
    let searchTaskId = searchFilter.value === false ? "all" : selectedTaskId.value
    if (target !== "") {
        store.dispatch(`browser/${BrowserActions.asyncGetSearchTypeList}`, { projId, uid, target, taskId, searchTaskId })
    } else {
        ElMessage({
            message: '搜索内容不能为空',
            type: 'error',
        })
    }
}

const asyncGetDefaultType = async (projId: string, uid: string, taskId: string) => {
    await store.dispatch(`browser/${BrowserActions.asyncGetDefaultBrowserHistory}`, { projId, uid, taskId });
    selected.value = [selectedBrowserType.value.browserType, selectedBrowserType.value.browserUser, selectedBrowserType.value.infoType]
}


const handleExpand = () => {
    cascaderRef.value.togglePopperVisible(true)
}

const exitSearch = () => {
    searchInput.value = ""
    store.commit(`browser/${BrowserMutations.setIsSearching}`, false)
}
const asyncGetBrowserTaskListByProjIdAndUid = async (projId: String, uid: string) => {
    await store.dispatch(`browser/${BrowserActions.asyncGetTaskListByProjIdAndUid}`, { projId, uid });
}

const handleChangeTask = async () => {
    const projId = projectId.value;
    const uid = targetId.value
    await asyncGetTypeList(projId, uid, selectedTaskId.value)
    await asyncGetDefaultType(projId, uid, selectedTaskId.value)
}

onMounted(async () => {
    const projId = projectId.value;
    const uid = targetId.value
    await asyncGetBrowserTaskListByProjIdAndUid(projId, uid)
    await asyncGetTypeList(projId, uid, selectedTaskId.value)
    await asyncGetDefaultType(projId, uid, selectedTaskId.value)
});

expose({
    handleChangeTask
})


return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_text, { class: "browserType-cascader-text" }, {
        default: _withCtx(() => [
          _createTextVNode(" 请选择 (浏览器/用户/信息类型) ")
        ]),
        _: 1
      }),
      _createVNode(_component_el_cascader, {
        ref_key: "cascaderRef",
        ref: cascaderRef,
        modelValue: selected.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
        options: _unref(typeList),
        onChange: handleChange,
        style: {"width":"500px"},
        clearable: "",
        placeholder: "浏览器/用户/信息类型",
        onExpandChange: handleExpand
      }, null, 8, ["modelValue", "options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        class: "browserType-search-input",
        modelValue: searchInput.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchInput).value = $event)),
        placeholder: "搜索",
        onKeydown: _withKeys(asyncGetTarget, ["enter"])
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: searchFilter.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchFilter).value = $event)),
            placeholder: "搜索范围",
            style: {"width":"100px"},
            onChange: handleChangeSearchInputFilter
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "全量",
                value: false
              }),
              _createVNode(_component_el_option, {
                label: "当前任务",
                value: true,
                disabled: _unref(browserTaskIdList) === null || _unref(browserTaskIdList).length === 0
              }, null, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            modelValue: searchType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchType).value = $event)),
            placeholder: "搜索类型",
            style: {"width":"80px","margin-left":"20px"},
            onChange: handleChangeSearchType
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "模糊",
                value: true
              }),
              _createVNode(_component_el_option, {
                label: "精确",
                value: false
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "onKeydown"]),
      _createVNode(_component_el_button_group, { class: "browserType-search-button" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            icon: _unref(Search),
            onClick: asyncGetTarget
          }, null, 8, ["icon"]),
          _createVNode(_component_el_popover, {
            placement: "top-start",
            width: "50px",
            trigger: "hover",
            content: "退出搜索"
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                icon: _unref(CloseBold),
                onClick: exitSearch
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ])), [
    [_directive_loading, _unref(isTypesLoading)]
  ])
}
}

})